import FormField from './field.js';
import DataLayerHelper from '../../utils/datalayer-helper';

export default class GAClientID extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.input = this.inputs[0].el;
        this.populate();
    }

    populate(){
        const gaClientID = DataLayerHelper.getClientId();
        this.input.value = gaClientID || '';
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_ga_client_id');
    }
}